import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

Vue.filter('addressFormat', function (value) {
    let arAddr = []

    if (value.address_1.length > 0) {
        arAddr.push(value.address_1)
    }

    if (value.address_2.length > 0) {
        arAddr.push(value.address_2)
    }

    if (value.city.length > 0) {
        arAddr.push(value.city)
    }

    if (value.state.length > 0) {
        arAddr.push(value.state)
    }

    let addr = arAddr.join(', ')

    if (value.zip.length > 0) {
        addr += value.zip
    }

    return addr
})

Vue.filter('phoneFormat', function (value) {
    let phone = value.replace(/\D+/, '')

    if (phone.length === 11) {
        if (phone.substr(0, 1) === '1') { // USA
            phone = phone.substr(1, 3) + '-' + phone.substr(4, 3) + '-' + phone.substr(7, 4)
        } else {
            phone = '+' + phone.substr(0, 1) + ' (' + phone.substr(1, 3) + ') ' + phone.substr(4, 3) + '-' + phone.substr(7, 4)
        }
    } else {
        phone = value
    }

    return phone
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app-concierge')
